import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import {
  LeftIcon,
  MouseRightClickIcon,
  RightIcon,
  CancelIcon,
} from "../../assets/icons/WorkTypeIcons";
import { PotreeGenerateAreaStore } from "../../Store/PotreeStore";
import { useCustomAlertStore } from "../../Store/store";

const IntroduceGeneratePathContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  color: #fff;
  box-sizing: border-box;

  .cancel-button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    background-color: #ffffff2d;
    border: #fff 1px solid;
    color: #fff;
    padding: 10px;

    position: absolute;
    top: 20px;
    right: 20px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
  .introduce-generate-path-content {
    padding: 20px;
    box-sizing: border-box;
    gap: 10px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 50%;
    max-width: 1000px;
    max-height: 700px;
    overflow: hidden;

    background-color: #61616130;
    border-radius: 10px;
    border: 2px solid #9d9d9d;
    z-index: 1000;
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
  }
  p {
    font-size: 17px;
    font-weight: 400;
    margin-bottom: 10px;

    span {
      color: #00ff99;
      font-weight: 600;
    }
  }

  .confirm-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 300px;
    height: 40px;
    margin-top: 20px;
    background-color: rgba(0, 255, 153, 0.1);
    border: 1px solid #00ff99;
    padding: 25px 20px;
    color: #00ff99;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    opacity: 1;
    visibility: visible;
    transition: all 0.3s ease-in-out;

    &.hidden {
      opacity: 0;
      visibility: hidden;
    }
  }

  .introduce-image-container-wrapper {
    overflow-x: hidden;
    overflow-y: hidden;
    width: 100%;
    height: 100%;
    max-width: 600px;
    position: relative;
    flex: 1;
    min-height: 0;
  }

  .introduce-slides-container {
    display: flex;
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease-in-out;
  }

  .introduce-image-container {
    position: relative;
    flex: 0 0 100%;
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &.icon {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 0 0 100%;
      svg {
        width: 100px;
        height: 100px;
      }
    }
  }
`;

const MainContainer = styled.main`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex: 1;
  min-height: 0;
  max-height: 400px;

  button {
    width: 50px;
    height: 100px;
    background-color: rgba(0, 255, 153, 0.1);
    border: 1px solid #00ff99;
    color: #00ff99;
    border-radius: 5px;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

export default function IntroduceGeneratePath({
  viewer,
  startAreaMeasurement,
  endAreaMeasurement,
  GeneratePath,
  SelectedStartPoint,
}) {
  const { showInfoAlert } = useCustomAlertStore();
  const [step, setStep] = useState(1);
  //   const [isMeasuring, setIsMeasuring] = useState(false);
  const isMeasuringRef = useRef(false);

  const slidesContainerRef = useRef(null);

  const totalSlides = 3; // 이미지 2개 + 아이콘 1개
  const { setIsStartAreaGenerate } = PotreeGenerateAreaStore();

  // 이미지 슬라이드
  useEffect(() => {
    if (slidesContainerRef.current) {
      const translateX = -(step - 1) * 100;
      slidesContainerRef.current.style.transform = `translateX(${translateX}%)`;
    }
  }, [step]);

  useEffect(() => {
    if (!viewer) return;

    const handleMouseDown = (e) => {
      if (!isMeasuringRef.current) return;

      if (e.button !== 2) return;

      endAreaMeasurement();

      setTimeout(() => {
        showInfoAlert(
          "출발 지점을 선택해주세요.",
          `생성한 영역 내에 좌클릭으로 출/복귀 지점을 지정할 시, 가장 가까운 내벽으로 출발 지점을 설정합니다.`,
        );
        SelectedStartPoint();
      }, 500);
      isMeasuringRef.current = false;
    };

    const canvas = viewer.renderer.domElement;
    canvas.addEventListener("mousedown", handleMouseDown, {
      capture: true,
    });
  }, []);

  useEffect(() => {
    // esc로 닫기 버튼 실행
    const handleEscKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsStartAreaGenerate(false);
      }
    };

    // 좌 우 화살표 버튼으로 handlePrevious, handleNext 실행
    const handleArrowKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        setStep((prevStep) => {
          if (prevStep > 1) {
            return prevStep - 1;
          }
          return prevStep;
        });
      } else if (e.key === "ArrowRight") {
        setStep((prevStep) => {
          if (prevStep < totalSlides) {
            return prevStep + 1;
          }
          return prevStep;
        });
      }
    };

    // 엔터로 확인 버튼 실행
    // const handleEnterKeyDown = (e) => {
    //   if (e.key === "Enter") {
    //     // step의 최신 값을 확인하기 위해 함수형 업데이트 사용
    //     if (step !== totalSlides) return;
    //     setIsStartAreaGenerate(false);
    //     isMeasuringRef.current = true;
    //     startAreaMeasurement();
    //   }
    // };

    window.addEventListener("keydown", handleEscKeyDown);
    window.addEventListener("keydown", handleArrowKeyDown);
    // window.addEventListener("keydown", handleEnterKeyDown);
    return () => {
      window.removeEventListener("keydown", handleEscKeyDown);
      window.removeEventListener("keydown", handleArrowKeyDown);
      //   window.removeEventListener("keydown", handleEnterKeyDown);
    };
  }, [totalSlides, setIsStartAreaGenerate, startAreaMeasurement]);

  const handleClick = () => {
    if (step !== totalSlides) return;
    setIsStartAreaGenerate(false);
    isMeasuringRef.current = true;
    startAreaMeasurement();
  };

  const handlePrevious = () => {
    setStep((prevStep) => {
      if (prevStep > 1) {
        return prevStep - 1;
      }
      return prevStep;
    });
  };

  const handleNext = () => {
    setStep((prevStep) => {
      if (prevStep < totalSlides) {
        return prevStep + 1;
      }
      return prevStep;
    });
  };

  return (
    <IntroduceGeneratePathContainer>
      <div className="introduce-generate-path-content">
        <button
          className="cancel-button"
          onClick={() => setIsStartAreaGenerate(false)}
          aria-label="취소"
          title="취소"
        >
          {CancelIcon}
        </button>
        {(step === 1 || step === 2) && <h2>영역 지정</h2>}
        {step === 3 && <h2>출발 지점 지정</h2>}

        {step === 1 && (
          <p>
            마우스 <span>좌클릭</span>을 통해 영역을 지정할 수 있습니다.
          </p>
        )}
        {step === 2 && (
          <p>
            마우스 <span>우클릭</span>을 통해 영역 지정을 완료해주세요.
          </p>
        )}
        {step === 3 && (
          <p>
            마우스 <span>좌클릭</span>을 통해 출발 지점을 지정할 수 있습니다.
          </p>
        )}
        <MainContainer>
          <button onClick={handlePrevious}>{LeftIcon}</button>
          <div className="introduce-image-container-wrapper">
            <div
              className="introduce-slides-container"
              ref={slidesContainerRef}
            >
              <div className="introduce-image-container">
                <img src="/introduceImage1.png" alt="introduce-image" />
              </div>
              <div className="introduce-image-container icon">
                {MouseRightClickIcon}
              </div>
              <div className="introduce-image-container">
                <img src="/introduceImage2.png" alt="introduce-image" />
              </div>
            </div>
          </div>
          <button onClick={handleNext}>{RightIcon}</button>
        </MainContainer>
        <button
          className={`confirm-button ${step !== totalSlides ? "hidden" : ""}`}
          onClick={handleClick}
        >
          영역 지정 시작
        </button>
      </div>
    </IntroduceGeneratePathContainer>
  );
}
